var React = require('react');

function DeliveryNotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M13.556 10.444h4.277l-4.277-4.277v4.277ZM6.556 5h7.777L19 9.667v7.777A1.556 1.556 0 0 1 17.444 19H6.556C5.692 19 5 18.3 5 17.444V6.556A1.55 1.55 0 0 1 6.556 5Zm0 1.556v10.888h10.888V12H12V6.556H6.556Z"}));
}

DeliveryNotes.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = DeliveryNotes;

DeliveryNotes.default = DeliveryNotes;
